//#region src/jwt.ts
/**
* Decode the payload of a JWT without verifying the signature.
* Returns the `exp` claim (seconds since epoch) or undefined.
*
* Use only for trusted tokens (e.g. ones we just received from our own proxy)
* where the goal is scheduling refresh, not authenticating the issuer.
*/
function getJwtExpiry(jwt) {
	const parts = jwt.split(".");
	if (parts.length !== 3) return void 0;
	try {
		const payload = JSON.parse(Buffer.from(parts[1], "base64url").toString());
		return typeof payload.exp === "number" ? payload.exp : void 0;
	} catch {
		return;
	}
}

//#endregion
export { getJwtExpiry as t };
//# sourceMappingURL=jwt2.mjs.map